/**
 * Six days of one group's verdicts — the chapter-8 story: pass, pass, a FAIL
 * (burned + stopped — 21/10/2026: a FAIL burns at once), the next list, a
 * depleted skip, paused.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DropGenGroupVerdict } from '@trafficpulse/shared';

import { CLICKERS_LISTS } from './demo-day';
import { CLEARANCE_CLICKS } from './demo-plan';

export const DEMO_RULE_SENTENCE =
  'the list is terrible when Delivered Rate is under 85% or Bot Rate is over 15%';
const TERRIBLE = 'Delivered Rate 62% is < 85% · Bot Rate 33% is > 15%';
const NOTHING_SENT = 'nothing sent yet today — nothing to judge';

const base = (over: Partial<DropGenGroupVerdict>): DropGenGroupVerdict => ({
  containerId: CLEARANCE_CLICKS.id,
  containerName: CLEARANCE_CLICKS.name,
  listGroupId: 'g-clickers',
  groupName: 'clickers',
  listWiserId: CLICKERS_LISTS[1].wiserId,
  listName: CLICKERS_LISTS[1].name,
  verdict: 'PASS',
  reason: 'nothing matched the terrible rule on 3,000 SMS across 10 drops',
  smsSent: 3000,
  dropsSent: 10,
  dropsPlanned: 29,
  conditions: [],
  action: 'none',
  ...over,
});

export interface DemoVerdictDay {
  day: string;
  note: string;
  /** null = nothing judged that day (nothing to judge, or paused). */
  verdict: DropGenGroupVerdict | null;
}

export const DEMO_VERDICT_DAYS: DemoVerdictDay[] = [
  { day: 'D1', note: 'healthy — keeps its list', verdict: base({}) },
  { day: 'D2', note: 'still healthy — keeps its list', verdict: base({ reason: 'nothing matched the terrible rule on 2,400 SMS across 8 drops', smsSent: 2400, dropsSent: 8 }) },
  { day: 'D3', note: 'FAIL — burned, the rest of today stops', verdict: base({ verdict: 'FAIL', reason: TERRIBLE, action: 'burned_and_stopped' }) },
  { day: 'D4', note: 'tomorrow starts on the next list', verdict: base({ listWiserId: CLICKERS_LISTS[0].wiserId, listName: CLICKERS_LISTS[0].name, verdict: 'INCONCLUSIVE', reason: NOTHING_SENT }) },
  { day: 'D5', note: 'a list with no numbers left is skipped the same way', verdict: base({ listWiserId: CLICKERS_LISTS[2].wiserId, listName: CLICKERS_LISTS[2].name, verdict: 'INCONCLUSIVE', reason: NOTHING_SENT }) },
  { day: 'D6', note: 'every list burned — paused until Reset pool', verdict: null },
];
